import { ACTION_TYPES } from '~/core/constants'
import logger from './logger'

let injectedLogger

const internalLoggerWrapper = {
  log: {
    info: logger.info,
    error: logger.error,
    warn: logger.warn
  },
  default: {
    getStorage: logger.getAllLogs
  }
}

const LOG_PREFIX = '[JITSI MEET]'
const LOG_PREFIX_IN_MEETING = '[JITSI MEET][IN-MEETING]'

const service = {
  get logger () {
    return injectedLogger || internalLoggerWrapper
  }
}

export const getAllLogs = () => service.logger.default.getStorage()

export const logInfo = (params, msg) => {
  service.logger.log.info(params, `${LOG_PREFIX} - ${msg}`)
}

export const logError = (rawPayload, msg) => {
  const { __filename, ...payload } = rawPayload

  const start = performance.now()

  let dummy
  if (Error.captureStackTrace) {
    const savedStackTraceLimit = Error.stackTraceLimit
    dummy = Object.create(null)
    Error.stackTraceLimit = 4
    Error.captureStackTrace(dummy)
    Error.stackTraceLimit = savedStackTraceLimit
  }
  const { stack } = dummy || new Error()

  const callsite = {
    callstack: stack.split('\n').slice(0, 4),
    originalFile: __filename,
    // eslint-disable-next-line no-bitwise
    t: performance.now() - start | 0
  }

  service.logger.log.warn({ callsite, args: payload }, `${LOG_PREFIX} - ${msg}`)
}

export const logInMeetingMessage = ({ logLevel, args }) => {
  service.logger.log[logLevel]({ args }, LOG_PREFIX_IN_MEETING)
}

const removeKey = key => ({ [key]: _, ...rest }) => rest

const sanitizePayload = (type, payload) => {
  const { EVENTS, RECENTS } = ACTION_TYPES
  const removeSummary = removeKey('summary')

  switch (type) {
    case EVENTS.FETCHED_EVENTS: {
      return payload.map(removeSummary)
    }
    case EVENTS.UPDATE_EVENT: {
      return removeSummary(payload)
    }
    case RECENTS.FETCHED_RECENTS: {
      return Object.keys(payload)
    }
    default:
      return payload
  }
}

export const reduxLightLogger = () => () => next => action => {
  const { type, payload } = action
  const loggedPayload = sanitizePayload(type, payload)

  logInfo({ loggedPayload, type }, `${LOG_PREFIX} [REDUX] Action dispatched`)
  return next(action)
}

export const setLogger = lib => {
  injectedLogger = lib
}
